import { createQueryKeys } from '@lukemorales/query-key-factory'

import { MentorCloudFileFilters } from 'src/types/files/file'

const mentorCloud = createQueryKeys('mentorCloud', {
  all: {
    queryKey: null
  },
  folder: (folderId: number) => {
    return { queryKey: [folderId] }
  },
  files: (folderId: number | null, filters: MentorCloudFileFilters) => {

    const order = { column: filters.order.column, ascending: filters.order.ascending }
    if (folderId === null) return { queryKey: [{ folderId: 'null', order, search: filters.search, type: filters.type }], }

    return { queryKey: [{ folderId, order, search: filters.search, type: filters.type }] }
  },
})

export default mentorCloud
